var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 30 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 16L2 18.5L15.5 25.5L28 17.5L24 15.5",
    stroke: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10.5L2 13.5L15.5 20.5L28 12.5L23 10",
    stroke: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4903 15.4261L1.98967 8.63319L14.0005 0.576885L27.9819 7.51936L15.4903 15.4261Z",
    fill: "transparent",
    stroke: "#999999"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8662 3.81303L13.841 3.30058L12.8929 3.94464L8.3505 7.03029L7.39502 7.67935L8.43516 8.18169L16.3296 11.9943L21.999 8.49616L23 7.87853L21.9479 7.35266L21.8915 7.32444L20.9331 7.96337L20.9469 7.97029L16.2709 10.8555L13.4096 9.47359L17.7867 6.40962L17.7691 6.3845L16.7831 5.89149L12.3777 8.97525L9.39064 7.53262L13.9181 4.45709L13.932 4.46406L14.8904 3.82513L14.8662 3.81303Z",
    fill: "#999999"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a4c67818.svg";
export { ForwardRef as ReactComponent };